module.exports = __webpack_public_path__ + "static/img/dd.8cd2d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/dd.png
// module id = R8ta
// module chunks = 0